const indexItems = [
  { title: '国产剧情精选', count: '120+ 部', icon: 'ri-movie-2-line', color: 'primary' as const },
  { title: '91传媒视频在线', count: '80+ 部', icon: 'ri-film-line', color: 'accent' as const },
  { title: '高清合集专区', count: '200+ 部', icon: 'ri-play-list-2-line', color: 'secondary' as const },
  { title: '每日更新推荐', count: '50+ 部/日', icon: 'ri-calendar-check-line', color: 'primary' as const },
  { title: '91国产小视频', count: '350+ 部', icon: 'ri-vidicon-line', color: 'accent' as const },
  { title: '经典老片修复', count: '90+ 部', icon: 'ri-history-line', color: 'secondary' as const },
  { title: '悬疑推理剧场', count: '65+ 部', icon: 'ri-search-eye-line', color: 'primary' as const },
  { title: '都市情感故事', count: '100+ 部', icon: 'ri-heart-line', color: 'accent' as const },
  { title: '动作冒险大片', count: '75+ 部', icon: 'ri-rocket-line', color: 'secondary' as const },
];

const colorConfig = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-500', border: 'border-primary-200/50' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-500', border: 'border-accent-200/50' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-500', border: 'border-secondary-200/50' },
};

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-heading font-bold text-foreground-950">
            专题索引
          </h2>
          <p className="mt-3 text-sm text-foreground-600 max-w-[560px] mx-auto">
            按分类快速浏览91免费视频网站的全部国产免费视频资源
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item) => {
            const c = colorConfig[item.color];
            return (
              <div
                key={item.title}
                className={`flex items-center gap-4 p-4 rounded-xl bg-background-50 border ${c.border} transition-all duration-200 hover:-translate-y-0.5 cursor-pointer`}
              >
                <div className={`w-11 h-11 rounded-lg ${c.bg} flex items-center justify-center flex-shrink-0`}>
                  <i className={`${item.icon} ${c.icon} text-lg w-5 h-5 flex items-center justify-center`}></i>
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 whitespace-nowrap truncate">{item.title}</h3>
                  <p className="text-xs text-foreground-500 mt-0.5 whitespace-nowrap">{item.count}</p>
                </div>
                <i className="ri-arrow-right-s-line text-foreground-400 w-5 h-5 flex items-center justify-center ml-auto"></i>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}